import axios from 'axios';
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import httpClient from '../../httpClient';

class SmallDiscussRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            friendUser : null,
            lastMsg : null
        }
    }
    conversation = this.props.conversation
    user = this.props.currentUser
    
    
    getLastMessage = async()=>{
        const host  = process.env.REACT_APP_SERVER_URL
        const res = await axios.get(host+"/api/messages/"+this.conversation._id)
    
        this.setState({lastMsg : res.data[res.data.length-1].message}) 
        
    }

    getUser =  () =>{
      let friendId = this.conversation.members.find((m)=> m !== this.user._id)
      httpClient.getUser(friendId).then(
          res => {
          
             
                this.setState({friendUser : res.name})
        
          }
      )
    }
    
    componentDidMount (){
        this.getUser()
        this.getLastMessage()
        console.log(this.state.lastMsg);
       
    }
    render() {
        return (
            <>
            <NavLink to={{
                pathname:"/messagerie/"+this.conversation._id,
                state: {convId : this.conversation._id, friendName : this.state.friendUser, conversation : this.conversation}
            }}>
                
            <div className="discussRow d-flex ">
                     <div className="d-flex align-items-center">

                        {this.props.admin ?  <img src="/imgs/dash/admin_circle.svg" className="mr-2" width="35px" alt="" />:<img src="/imgs/dash/conv_circle.svg" className="conv__circ mr-2" width="35px" alt="" />}
                       
                        <div className="conv__txt d-flex flex-column">
                            <span className="conv__profile_sm smDiscuss">{this.state.friendUser}</span>
                            <span className="conv__msg lastMsg">
                               { this.state.lastMsg?.includes("/api") ? <span>Photo</span> :this.state.lastMsg}
                            </span>
                        </div>
                     </div>
                    
            </div>
         
            </NavLink>
            </>
        );
    }
}

export default SmallDiscussRow;
